import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "appointment-filter-list",
      attrs: { "data-qa": "appointment-type-filter-list" },
    },
    [
      _c(
        VChipGroup,
        {
          staticClass: "mt-2",
          attrs: { mandatory: "" },
          model: {
            value: _setup.filterType,
            callback: function ($$v) {
              _setup.filterType = $$v
            },
            expression: "filterType",
          },
        },
        [
          _vm._l(_vm.placeTypes, function (placeType) {
            return [
              _c(
                VChip,
                {
                  key: placeType,
                  staticClass: "appointment-filter-list__chip",
                  attrs: {
                    value: placeType,
                    outlined: "",
                    "active-class": "primary",
                    "data-qa": "appointment-type-filter-list__chip",
                  },
                  on: { click: _setup.handleFilterTabClick },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(_setup.CHIP_LABELS[placeType], _setup.options)
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }